export enum Enum_Input_Types {
    TEXT = "text",
    NUMBER = "number",
    DATE = "date",
    CHECKBOX = "checkbox",
    RADIO = "radio",
    TEXTAREA = "textarea",
    DROPDOWN = "dropdown",
}
